"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aiConfigProviderSchema = exports.aiConfigTypeSchema = void 0;
const zod_1 = require("zod");
const catalog_1 = require("./catalog");
exports.aiConfigTypeSchema = zod_1.z.string().superRefine((value, context) => {
    if (!(0, catalog_1.isAiConfigType)(value)) {
        context.addIssue({
            code: 'custom',
            message: (0, catalog_1.getAiConfigTypeValidationMessage)(value),
        });
    }
}).transform((value) => value);
exports.aiConfigProviderSchema = zod_1.z.string().superRefine((value, context) => {
    if (!(0, catalog_1.isAiConfigProvider)(value)) {
        context.addIssue({
            code: 'custom',
            message: `Unknown AI config provider "${value}"`,
        });
    }
}).transform((value) => value);
